import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../components/form/SearchInput";
import Loader from "../components/other/Loader";
import { fetchAllGroups } from "../redux/action/groupAction";
import {
  BASE_URL,
  firebaseRemoveUserFromGroupAPI,
  getAllFirebaseGroupAPI,
} from "../routes/apiEndPoints";
import axios from "axios";
import NoRecord from "../components/other/NoRecord";
import { message } from "antd";
import PaginationDropdown from "../components/PaginationDropdown";
import ReactPagination from "../components/reactPagination";
import { Navigate, useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";

const Groups = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isToggle } = useSelector((state) => state.authReducer);
  // const { isLoading, publicChatGroups, privateChatGroups } = useSelector(
  //   (state) => state.groupReducer
  // );
  const [publicChatGroup, setGetPublicChatGroup] = useState([]);
  const [privateChatGroup, setGetPrivateChatGroup] = useState([]);
  const [mergeGroup, setMergeGroup] = useState([]);
  const [loader, setLoader] = useState(false);
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);

  const [filteredSubscriptions, setFilteredSubscriptions] = useState([]);
  const [filterCriteria, setFilterCriteria] = useState({
    groupType: "",
    searchQuery: "",
  });
  const [selecteduser, setSelectedUser] = useState({});
  const [selectedGroupImage, setSelectedGroupImage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  // useEffect(() => {
  //   dispatch(fetchAllGroups());
  // }, [dispatch]);

  useEffect(() => {
    getgroup();
  }, []);

  const getgroup = () => {
    setLoader(true);
    const token = localStorage.getItem("access-token");
    axios({
      method: "get",
      url: BASE_URL + getAllFirebaseGroupAPI,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setGetPrivateChatGroup(res?.data?.data?.privateChatGroup);
        setGetPublicChatGroup(res?.data?.data?.publicChatGroup);
        const test = [
          ...res?.data?.data?.publicChatGroup,
          ...res?.data?.data?.privateChatGroup,
        ];
        setSelectedUser(test[0]);
        setMergeGroup(test);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleGroupClick = (groupIndex, group) => {
    setActiveGroupIndex(groupIndex);
  };

  useEffect(() => {
    const filtered = mergeGroup.filter((item) => {
      const matchesType =
        !filterCriteria.groupType ||
        item.groupType === filterCriteria.groupType;
      const matchesSearch =
        !filterCriteria.searchQuery ||
        item.groupName
          .toLowerCase()
          .includes(filterCriteria.searchQuery.toLowerCase());

      return matchesType && matchesSearch;
    });
    setFilteredSubscriptions(filtered);
  }, [filterCriteria, mergeGroup]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formatTimestamp = (seconds, nanoseconds) => {
    if (!seconds) return "Invalid timestamp";
    const milliseconds = seconds * 1000 + Math.floor(nanoseconds / 1e6);
    const date = new Date(milliseconds);
    const options = {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    // return new Intl.DateTimeFormat("en-US", options).format(date);

    const formattedDateTime = new Intl.DateTimeFormat("en-US", options).format(
      date
    );
    return formattedDateTime.replace(/, /g, "   ");
  };

  const paginatedGroup = filteredSubscriptions?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleGroupImage = (group) => {
    setSelectedGroupImage(group.groupImage);
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
          <Sidebar />
          <div class="ct_right_content">
            <Header />
            <div class="ct_inner_dashbaord_main">
              <div class="ct_right_header">
                <div class="ct_left_header_cnt">
                  <div class="form-group">
                    <label for="" class="mb-2 ct_fw_600">
                      Type
                    </label>
                    <select
                      name="groupType"
                      className="form-control ct_input ct_pointer_curser"
                      value={filterCriteria.groupType}
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      <option value="public">Public</option>
                      <option value="private">Private</option>
                    </select>
                  </div>

                  {/* <SearchInput onSearch={handleSearch} /> */}
                  <div className="form-group">
                    <label
                      htmlFor=""
                      className="mb-2 ct_fw_600 ct_nbsp_none_1199"
                    >
                      &nbsp;
                    </label>
                    <div className="position-relative">
                      <i className="fa-solid fa-magnifying-glass ct_search_icon_12"></i>
                      <input
                        type="text"
                        className="form-control ct_input ct_text_indent_30"
                        placeholder="Search"
                        name="searchQuery"
                        value={filterCriteria.searchQuery}
                        onChange={handleFilterChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                  <div class="">
                    <div class="">
                      <div>
                        <ul class="d-flex align-items-center  gap-2 mb-0">
                          <li>
                            {" "}
                            <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                              All Groups
                            </h4>
                          </li>
                          <li>
                            {" "}
                            <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                              <i class="bi bi-dot"></i>
                            </h4>
                          </li>
                          <li>
                            {" "}
                            <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                              {mergeGroup.length}{" "}
                              {mergeGroup.length <= 1 ? "Group" : "Groups"}
                            </h4>
                          </li>
                        </ul>
                      </div>
                      <div class="table-responsive">
                        <table class="table ct_custom_table">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Group Image</th>
                              <th>Name & Location</th>
                              <th>Group Type</th>
                              <th>Group Creation Date</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedGroup && paginatedGroup != 0 ? (
                              paginatedGroup.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <img
                                          src={
                                            item?.groupImage
                                              ? item?.groupImage
                                              : "/user_profile.png"
                                          }
                                          alt=""
                                          data-bs-toggle="modal"
                                          data-bs-target="#ct_user_img_preview"
                                          class="ct_img_60 ct_pointer_curser"
                                          onClick={() => handleGroupImage(item)}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div class="d-flex align-items-center gap-2">
                                        <div>
                                          <h5 class="ct_fs_14 ct_fw_700 mb-0">
                                            {item?.groupName}
                                          </h5>
                                          <p class="mb-0 ct_fs_14 ct_fw_500">
                                            {item?.member.length}{" "}
                                            {item?.member.length > 1
                                              ? "members"
                                              : "member"}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <p class="mb-0 ct_fw_600 ct_fs_16 ct_fw_600 ct_green_text" style={{ textTransform: 'capitalize' }}>
                                          {item?.groupType ?? ''}
                                        </p>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <p class="mb-0 ct_fw_600 ct_fs_16">
                                          <span>
                                            {item?.createdAt &&
                                              formatTimestamp(
                                                item?.createdAt.seconds,
                                                item?.createdAt.nanoseconds
                                              )}
                                          </span>
                                        </p>
                                      </div>
                                    </td>
                                    <td class="text-start">
                                      <div>
                                        <div className="d-flex align-items-center gap-4">
                                          {item?.member.length != 0 ? (
                                            <a
                                              className=" ct_view_grey_btn  ct_pointer_curser"
                                              onClick={() => {
                                                handleGroupClick(index, item);
                                                setSelectedUser(item);
                                                navigate(
                                                  pageRoutes?.groupMember,
                                                  {
                                                    state: { member: item },
                                                  }
                                                );
                                              }}
                                            >
                                              {" "}
                                              <i class="fa-solid fa-eye ct_pointer_curser"></i>
                                            </a>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  {mergeGroup.length == 0 ? (
                                    <NoRecord />
                                  ) : (
                                    <h3 className="text-center">
                                      There are no results with this search.
                                    </h3>
                                  )}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {paginatedGroup && paginatedGroup?.length != 0 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center mt-4">
                        <div>
                          <PaginationDropdown
                            onChange={(val) => {
                              setUserPerPages(val);
                              setCurrentPage(0);
                            }}
                          />
                        </div>
                        <div>
                          <ReactPagination
                            pageCount={Math.ceil(
                              filteredSubscriptions?.length / usersPerPage
                            )}
                            onPageChange={handlePageClick}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      )}
      <div
        class="modal fade ct_assets_modal"
        id="ct_user_img_preview"
        tabindex="-1"
        aria-labelledby="ct_user_img_previewLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header pb-0 border-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mt-0">
              <img
                src={selectedGroupImage || "./user_profile.png"}
                alt=""
                class="ct_img_400_big"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Groups;
